import Header from './Header';

const CheckInbox = () => {
    return (
        <div className="best">
            <Header/>
            <div className="bredcrub">
        <div className="container">
            <ul>
                <li><a href="#">Home</a> <i className="fa-solid fa-angle-right"></i></li>
                <li>Register</li>
            </ul>
        </div>
    </div>

    <div className="checkbox">
        <h2>Check your inbox</h2>
        <p>An email with a verification link has been<br/>sent to your Email ID.</p>
        <button>Done</button>
    </div>

        </div>
    );
};
  
export default CheckInbox;